<template>
    <modal @close="$emit('close')" :autoshow="true" ref="modal" :is-closeable="isCloseable">
        <template v-slot:title>Edit Employee Information</template>

        <template v-slot:subheading>
            <div class="p-1 unpad-x bg-150 rounded">
                <div><span class="text-muted">Employee:</span> {{ employee.full_name }}</div>
                <div><span class="text-muted">Company:</span> {{ employee.company.name }}</div>
            </div>
        </template>

        <slot>
            <div>
                <form>
                    <form-errors :errors="formErrors"/>

                    <div class="form-row">
                        <div class="col-10">
                            <form-input label="First Name" v-model="formData.first_name" :errors="errors.first_name" type="text" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-10">
                            <form-input label="Middle Name" v-model="formData.middle_name" :errors="errors.middle_name" type="text" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-10">
                            <form-input label="Last Name" v-model="formData.last_name" :errors="errors.last_name" type="text" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-10">
                            <form-input label="Preferred Name" v-model="formData.preferred_name" :errors="errors.preferred_name" type="text" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-10">
                            <form-input label="Date of Birth" v-model="formData.dob" :errors="errors.dob" type="date" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-10">
                            <form-input label="Employment Category" type="select" :options="employmentCategoryOptions" v-model="formData.employment_category" :errors="errors.employment_category"/>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-10">
                            <form-input label="Start Date" v-model="formData.date_hired" :errors="errors.date_hired" type="date" />
                        </div>
                    </div>

                </form>
            </div>
        </slot>

        <template v-slot:footer>
            <div class="form-row">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                </div>
                <div class="col">
                    <button type="submit" class="btn btn-block btn-primary" @click.prevent="onSubmit">Save</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/ModalMixin'
import FormMixin from '@/mixins/Form'

export default {
    mixins: [ModalMixin, FormMixin],
    components: {},
    props: ['client', 'employee', ],
    data() {
        return {
            formData: this.makeFormData(),
            employmentCategoryOptions: [
                {text: 'Part Time', value: 'PT'},
                {text: 'Full Time', value: 'FT'},
            ]
        }
    },
    methods: {
        makeFormData() {
            return {
                first_name: this.employee.first_name,
                middle_name: this.employee.middle_name,
                last_name: this.employee.last_name,
                preferred_name: this.employee.preferred_name,
                dob: this.employee.dob,
                employment_category: this.employee.employment_category,
                date_hired: this.employee.date_hired,
            }
        },
        onSubmit() {
            this.errors = {}
            this.formErrors = []
            this.$api.patch(`/clients/${this.client.id}/employees/${this.employee.id}/info`, this.getFormData()).then(resp => {
                this.$emit('updated')
                this.close()
            }).catch(errors => {
                this.errors = errors
                this.formErrors = errors.__all__
            })
        },
    }
}
</script>
